import NullableFloat from '@/utils/customTypes/nullableFloat'
import { MapToContext } from '@utils/objectWithDefault'

export class ShippingLabelPricing {
  constructor (shippingLabelPricingData) {
    const defaultShippingLabelPricingData = {
      totalPrice: { val: 0, type: NullableFloat },
      totalWeight: { val: 0, type: NullableFloat },
      pricingGroupId: { val: 0, type: Number },
      pricingGroupName: { val: '', type: String },
      zone: { val: 0, type: Number },
      message: { val: null, type: PricingApiMessage },
      wroBoxPrices: { val: [], type: Array, subType: WroBoxPrices },
      totalBoxes: { val: 0, type: Number }
    }
    MapToContext(this, defaultShippingLabelPricingData, shippingLabelPricingData)
  }
}

export class PricingApiMessage {
  constructor (pricingApiMessageData) {
    const defaultPricingApiMessageData = {
      success: { val: false, type: Boolean },
      PricingMessage: { val: '', type: String }
    }
    MapToContext(this, defaultPricingApiMessageData, pricingApiMessageData)
  }
}

export class WroBoxPrices {
  constructor (wroBoxPricesData) {
    const defaultWroBoxPricesData = {
      price: { val: 0, type: NullableFloat },
      lengthInches: { val: 0, type: NullableFloat },
      widthInches: { val: 0, type: NullableFloat },
      heightInches: { val: 0, type: NullableFloat },
      weightInOz: { val: 0, type: NullableFloat },
      dimensionalWeight: { val: 0, type: NullableFloat },
      message: { val: null, type: PricingApiMessage }
    }
    MapToContext(this, defaultWroBoxPricesData, wroBoxPricesData)
  }
}
